import moment from 'moment';
import { useState } from 'react';
import useClickOutside from '../../../../useClickOutside';

export const ColumnCategory = (translate, warning, handleEdit, langLocal) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('description')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['description']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row,index) => (
                <div  >
                    {/*<i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>*/}
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => {setOptions(!options);setRowId(index)}}  ></i>
                    {
                        options && index === row_id && (
                            <div ref={domNode} className='div-actions shadow_main' style={langLocal === 'ar' ? { left: '20px' } : { left: '-100px' }} >
                                <span onClick={(e) => handleEdit(e, row)} >{translate('edit')}</span>
                                <span onClick={() => warning(row)} >{translate('delete')}</span>
                            </div>
                        )
                    }
                </div>
            )
        }
    ]
    return {
        columns
    }
}